import axios from "axios";
import { getCacheV1, setCacheV1 } from "./common";
import { getTelegramLoginParams, installSessionRecovery } from "./authSession";
import { getTurnstileToken, resetTurnstile } from "./turnstile";
import {
  isTurnstileProtectedUrl,
  shouldResetTurnstile,
} from "./turnstile.shared";
// let baseURL = ""
let baseURL = "https://" + TApp_GlobalConfig.api_host; // 全局配置拿
const service = axios.create({
  baseURL,
  timeout: 120 * 1000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
service.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};

    if (!isTurnstileProtectedUrl(config.url || "")) {
      return config;
    }

    return (async () => {
      const turnstileToken = await getTurnstileToken();
      if (turnstileToken) {
        config.headers["cf-turnstile-response"] = turnstileToken;
      }
      return config;
    })();
  },
  (errer) => {
    return Promise.reject(errer);
  },
);

service.interceptors.response.use(
  (response) => {
    if (
      shouldResetTurnstile({
        url: response.config?.url || "",
        data: response.data,
      })
    ) {
      resetTurnstile();
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 后注册的请求拦截器先执行，先恢复登录，再获取本次请求需要的人机验证凭证。
installSessionRecovery(service, {
  getToken: () => getCacheV1("token"),
  // 保持原来的六天前端缓存期限，到期后通过登录换取凭证。
  saveToken: (token) => setCacheV1("token", token, 8640),
  getLoginParams: () => getTelegramLoginParams(window.Telegram?.WebApp, TApp_GlobalConfig.project_id),
});

/**
 * 使用实例：
 * POST:
 *      reqest("/api/get",{
 *              method:"POST",
 *              params:params
 *      })
 * GET:
 *      reqest("/api/get?data=data")
 * 
*/
const Request = (url, options = {}) => {
  let method = options.method || "get";
  let params = options.params || {};

  if (method === "get" || method === "GET") {
    return new Promise((resolve, reject) => {
      service
        .get(url, {
          params: params,
        })
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  } else {
    return new Promise((resolve, reject) => {
      service
        .post(url, params)
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};
export {
  Request,
};
